import { render } from "./GeneralJournal.vue?vue&type=template&id=2aeb959e&scoped=true&ts=true"
import script from "./GeneralJournal.vue?vue&type=script&lang=ts"
export * from "./GeneralJournal.vue?vue&type=script&lang=ts"

import "./GeneralJournal.vue?vue&type=style&index=0&id=2aeb959e&scoped=true&lang=css"

import exportComponent from "/home/muhammadibrahim/Myserver/Medix_v4_envato/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aeb959e"]])

export default __exports__